module.exports = __webpack_public_path__ + "static/media/cementTruck_gray.68e01201.svg";